export interface StockExchange {
  shortName: string
}

export const StockExchangesList: StockExchange[] = [
  { shortName: "EPA" },
  { shortName: "LON" },
  { shortName: "NASDAQ" },
  { shortName: "NYSE" },
  { shortName: "TYO" },
]

export const GetStockExchangeByCode = (code: string): StockExchange => {
  let result

  if (code) {
    result = StockExchangesList.find(({ shortName }) => shortName === code)

    if (result) {
      result = {
        shortName: result.shortName,
      }
    }
  }

  return result
}
